import { render, staticRenderFns } from "./VOverlay.vue?vue&type=template&id=0389d9d3&scoped=true&"
import script from "./VOverlay.vue?vue&type=script&lang=js&"
export * from "./VOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VOverlay.vue?vue&type=style&index=0&id=0389d9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389d9d3",
  null
  
)

export default component.exports